module.exports = __webpack_public_path__ + "static/media/welcometitle.8f8d0282.png";